import { useQuery } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { scheduleKeys } from './scheduleKeys'

export const ACTIVE_GENERATION_BATCH_REFETCH_INTERVAL_MS = 60_000

export interface ActiveGenerationBatch {
  schedule_id: number
  total_count: number
  completed_count: number
  started_at: string | null
  is_active: boolean
}

export const fetchActiveGenerationBatch = async (scheduleId: number): Promise<ActiveGenerationBatch> => {
  const res = await sendToApi<ActiveGenerationBatch>(`/schedules/${scheduleId}/active_generation_batch`)

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(typeof res.data === 'string' ? res.data : 'Failed to fetch active generation batch')
  }
  return res.data
}

export const useActiveGenerationBatch = (scheduleId: number | null) => {
  const calendarV2 = useFlipperFlag('calendar_v2')

  return useQuery<ActiveGenerationBatch>({
    queryKey: scheduleKeys.activeBatch(scheduleId ?? 0),
    queryFn: () => fetchActiveGenerationBatch(scheduleId as number),
    enabled: calendarV2 && !!scheduleId,
    staleTime: Infinity,
    refetchInterval: ACTIVE_GENERATION_BATCH_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })
}
